import React from 'react';
import {DisplayText, TextStyle, TextContainer} from '@shopify/polaris';

import styles from './PageHeader.scss';

interface OwnProps {
  title: string;
  description: string;
  image: string;
  actions?: React.ReactNode;
}

export default function PageHeader({
  title,
  description,
  image,
  actions,
}: OwnProps) {
  return (
    <div className={styles.PageHeader}>
      <div className={styles.ContentContainer}>
        <TextContainer>
          {actions && actions}
          <DisplayText size="extraLarge" element="h1">
            {title}
          </DisplayText>
          <DisplayText size="medium">
            <TextStyle variation="subdued">
              <span className={styles.Description}>{description}</span>
            </TextStyle>
          </DisplayText>
        </TextContainer>
      </div>
      <div className={styles.ImageContainer}>
        <img src={image} alt="" className={styles.Image} />
      </div>
    </div>
  );
}
